import React from 'react';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { defineMessages, FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import TooltipMessage from '../../../components/shipment-status-icon/tooltip-message/index';

import style from '../shipment-status.module.less';

const messages = defineMessages({
  printed: {
    description: 'shipment-status.printed',
    defaultMessage: 'Printed',
    id: 'xTaoOv',
  },
  packingSlipPrinted: {
    description: 'shipment-status.packingSlipPrinted',
    defaultMessage: 'Packing Slip Printed',
    id: 'uXIYD2',
  },
  packingSlip: {
    description: 'shipment-status.packingSlip',
    defaultMessage: 'Packing Slip',
    id: 'GDEIHc',
  },
});

export default {
  id: 'packing-slip',
  generateProps: ({ packingSlipPrintedStatus, markPackingSlipPrinted }) => {
    const isPrinted = get(packingSlipPrintedStatus, 'isPrinted', false);
    const date = get(packingSlipPrintedStatus, 'modifiedDateTime');
    const message = isPrinted ? <FormattedMessage {...messages.printed} /> : undefined;

    const tooltipContent = isPrinted ? <TooltipMessage date={date} singleMessage={messages.packingSlipPrinted} /> : undefined;

    return {
      title: <FormattedMessage {...messages.packingSlip} />,
      status: isPrinted ? 'completed' : '',
      icon: faFileLines,
      message,
      tooltipContent,
      onIconClick: isPrinted ? markPackingSlipPrinted : undefined,
      clickable: isPrinted,
      key: 'packing-slip',
      iconStyle: style['packing-slip-icon'],
    };
  },
};
